// "5 minutes ago" wording for timestamps, the way Rails' time_ago_in_words
// reads. Stays relative forever ("2 years ago") — the exact moment rides on
// the <TimeAgo> hover title, never a cutover to a plain date.
//
// Built on the browser's Intl.RelativeTimeFormat: no library, and
// "yesterday" / "last month" come free from numeric: "auto".

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 365 * 86_400],
  ["month", 30 * 86_400],
  ["week", 7 * 86_400],
  ["day", 86_400],
  ["hour", 3_600],
  ["minute", 60],
];

const relative = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

// Largest unit that fits, truncated (1h59m reads "1 hour ago", never rounds
// up to "yesterday" at noon). `now` is injectable for tests only.
export function timeAgo(iso: string, now: number = Date.now()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const secs = Math.round((then - now) / 1000); // negative = past
  if (Math.abs(secs) < 60) return "just now";
  for (const [unit, size] of UNITS) {
    if (Math.abs(secs) >= size) return relative.format(Math.trunc(secs / size), unit);
  }
  return "just now";
}

// The exact moment for a hover title: "Sep 3, 2026, 2:15 PM".
export function exactTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
}
